import { useEffect, useState } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { MemberApi } from "../../api/MemberApi";
import MemberSkillStatTable from "./MemberSkillStatTable";
import { loadingSpinnerSx, mutedTextSx } from "../../styles/cyberTheme";

export default function MemberSkillStatPanel({ memberID, year = "" }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!memberID) {
            setLoading(false);
            setData([]);
            return;
        }

        let cancelled = false;

        const load = async () => {
            setLoading(true);
            setError("");
            try {
                const result = await MemberApi.getMemberSkillStat(memberID, year);
                if (!cancelled) {
                    setData(Array.isArray(result) ? result : []);
                }
            } catch (e) {
                if (!cancelled) {
                    setError("無法載入運動技能統計");
                    setData([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        load();
        return () => {
            cancelled = true;
        };
    }, [memberID, year]);

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <CircularProgress sx={loadingSpinnerSx} />
            </Box>
        );
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    return <MemberSkillStatTable data={data} />;
}
